import { render, staticRenderFns } from "./CategoryOrderComponent.vue?vue&type=template&id=c9b453ba"
import script from "./CategoryOrderComponent.vue?vue&type=script&lang=js"
export * from "./CategoryOrderComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports